import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

const get = (queryBuilder = "") => {
  return responseFormatter(
    http.get(`/sites${queryBuilder}`, {
      setAuthHeader: true,
   
    })   
  );
};

const patch = (id, payload) => {
  return responseFormatter(
    http.patch(`/site/${id}`, payload, {
      setAuthHeader: true,
     
    })
  );
};
const Service = {
  get,
  patch
};

export default Service;
